import React, { FunctionComponent, ReactElement } from 'react'
import * as S from './styled'
import ScreenContainer from '../../atoms/ScreenContainer'
import Spacer from 'react-styled-spacer'
import GoBackButton from '../../atoms/GoBackButton'
import { goBack, navigate } from '@app/navigation'
import ScreenWrapper from '../../atoms/ScreenWrapper'

type OwnProps = {
  LeftComponent: ReactElement
  RightComponent: ReactElement
  title?: string
  navigateBack?: () => void
  // Viewport width below which the two components stack instead of sitting
  // side by side
  stackBelow?: number
}

type Props = OwnProps

const TwoComponentPage: FunctionComponent<Props> = ({
  LeftComponent,
  RightComponent,
  title,
  navigateBack,
  stackBelow = 820,
}) => {
  return (
    <ScreenWrapper style={{ display: 'flex', flexDirection: 'column' }}>
      {typeof navigateBack === 'function' && (
        <div>
          <Spacer h={24} />
          <GoBackButton
            text="Go back"
            onPress={goBack}
            portraitMode={screen.width < screen.height}
            style={{ marginLeft: 24 }}
          />
        </div>
      )}

      <S.Card>
        {title && <S.Title>{title}</S.Title>}
        <S.ComponentContainer stackBelow={stackBelow}>
          {LeftComponent}
          {RightComponent}
        </S.ComponentContainer>
      </S.Card>
    </ScreenWrapper>
  )
}

export default TwoComponentPage
